import React from 'react';
import { Route, Router, Switch } from 'react-router-dom';
import LoginApi from '../services/login.service';
import Login from '../login';
import history from '../services/history.service';
import SuspenseErrorBoundaryWrapper from '../common/SuspenseErrorBoundaryWrapper';
import suspenseFallbackMessages from '../Constants/strings/suspense-fallback-messages';

const Main = React.lazy(() => import('../main/main.jsx'));

const api = new LoginApi();

class PrivateComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: false,
      isAuthenticated: false,
      roles: []
    };
  }

  authenticate() {
    if (!api.getLoginState()) {
      history.push('/');
      this.setState({
        isAuthenticated: false
      });
    } else {
      this.setState({
        isAuthenticated: true
      });
    }
  }

  componentWillMount() {
    this.authenticate();
  }

  render() {
    const { isAuthenticated } = this.state;
    return (
      <Router history={history}>
        <Switch>
          <Route
            path='/'
            render={(props) =>
              isAuthenticated ? (
                <SuspenseErrorBoundaryWrapper
                  fallbackMessage={suspenseFallbackMessages.Main}
                >
                  <Main {...props} {...this.props} />
                </SuspenseErrorBoundaryWrapper>
              ) : (
                <Login {...props} {...this.props} />
              )
            }
          />
        </Switch>
      </Router>
    );
  }
}

export default PrivateComponent;
